import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'aza-rws-profile-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.css'],
    standalone: false
})
export class HeaderComponent {
    @Input() titleTranslationKey: string;
    @Output() closed = new EventEmitter<void>();

    onClosed(): void {
        this.closed.next();
    }
}
